export enum FeatureToggle {
  BENES_BY_RELATION = 'benes_by_relation',
  SAVE_AS_DRAFT = 'save_as_draft',
  CONTROL_PERSON = 'control_person',
  GIFTING = 'gifting',
  GIFTING_SCALE_TOGGLE_V2 = 'gifting_scale_v2',
  CWP_IRA_SCALE_TRAD = 'cwp_ira_scale_trad',
  CWP_IRA_SCALE_INH_ROTH = 'cwp_ira_scale_inh_roth',
  INHERITANCE_ESTATE_SCALE_TOGGLE = 'cwp_ira_scale_estate',
  CWP_IRA_SCALE_TRUST = 'cwp_ira_scale_trust',
  CWP_INHERITANCE_IRA_QUESTION = 'cwp_inheritance_ira_question',
  JOINT_INHERITANCE = 'joint_inheritance',
  INHERITANCE_IRA = 'inheritance_ira',
  INHERITANCE_INDIVIDUAL = 'inheritance_individual',
  CWP_IRA_SCALE_TRUST_TO_TRUST = 'cwp_ira_scale_trust_to_trust',
  CWP_INTERNAL_GIFTING_MANAGED_ACCOUNTS = 'cwp_internal_gifting_managed_accounts',
  INTELLEDOX_REDIRECT_AND_THRESHOLDS = 'intelledox_redirect_and_thresholds',
  DOC_CHECKLIST_INHERITANCE = 'doc_checklist_inheritance',
  CWP_MULTI_INHERITANCE = 'cwp_multi_inheritance',
  CWP_MULTI_INHERITANCE_ESTATE = 'cwp_multi_inheritance_estate',
  CWP_INHERITANCE_SAVE_DRAFT = 'cwp_inheritance_save_draft',
  CWP_INHERITANCE_SAVE_DRAFT_INTERNAL = 'cwp_inheritance_save_draft_internal',
  CWP_CO0_MINOR = 'cwp_co0_minor',
  CWP_CO0_INHERITANCE = 'cwp_co0_inheritance',
  CWP_CO0_INTERNAL_TRANSFERS = 'cwp_co0_internal_transfers',
  CWP_CO0_UPLOAD = 'cwp_co0_upload',
  CWP_CO0_GIFTING = 'cwp_co0_gifting',
  CWP_DIVORCE = 'cwp_divorce',
  CWP_INHERITANCE_HIDE_SINGLE_FLOW = 'cwp_inheritance_hide_single_flow',
  CWP_GIFTING_ADVISED_ACCOUNTS = 'cwp_gifting_advised_accounts',
  CWP_MULTI_TRANSACTIONS_CREW = 'cwp_multi_transactions_crew',
  CWP_ACCOUNT_VALIDATION = 'cwp_account_validation',
  CWP_INHERITANCE_VCD = 'cwp_inheritance_vcd',
  CWP_IT_MULTI_RECEIVING = 'cwp_it_multi_receiving',
  CWP_PROSPECT_TO_AUTH_FIRST = 'cwp_prospect_to_auth_first',
  L8_ITW_UPLOAD = 'l8_itw_upload',
  CWP_VC_ORG_TO_ORG = 'cwp_vc_org_to_org',
  CWP_NON_VC_ORG_TRANSFER = 'cwp_non_vc_org_transfer',
  CWP_DOCUMENT_UPLOAD_MFE = 'cwp_document_upload_mfe',
  CWP_INHERITANCE_ORG_AS_BENE = 'cwp_inheritance_org_as_bene',
  CWP_MO_GIFTING = 'cwp_mo_gifting',
  CWP_INHERITANCE_INDIVIDUAL_JOINT_TO_TRUST = 'cwp_inheritance_individual_joint_to_trust',
  CWP_INHERITANCE_RESTRICT_DUP_TRANSACTIONS = 'cwp_inheritance_restrict_dup_transactions',
  CWP_INHERITANCE_DECEDENT_SECURITY = 'cwp_inheritance_decedent_security',
  CWP_INHERITANCE_CHECKLIST_GET_STARTED = 'cwp_inheritance_checklist_get_started',
  CWP_TERMS_W9_REDESIGN = 'cwp_terms_w9_redesign',
  CWP_MULTI_IT_MO = 'cwp_multi_it_mo',
  CWP_INHERITANCE_ADVISED_CLIENT_WARNINGS = 'cwp_inheritance_advised_client_warnings',
  CWP_INHERITANCE_SAVE_STATE = 'cwp_inheritance_save_state',
  CWP_INHERITANCE_NEW_TERMS = 'cwp_inheritance_new_terms',
  CWP_MINOR_SAVE_DRAFT = 'cwp_minor_save_draft',
  CWP_CASH_PLUS_SWEEP_TRANSFER = 'cwp_cash_plus_sweep_transfer',
  CWP_BUY_SELL_HOME_URL_ROUTING = 'cwp_buy_sell_home_url_routing',
  CWP_VIADOC_SHADOW_MODE = 'cwp_viadoc_shadow_mode',
}

export const FeatureToggleObject = Object.keys(FeatureToggle).reduce((obj, key) => {
  return {
    ...obj,
    [key]: FeatureToggle[key as keyof typeof FeatureToggle],
  };
}, {});
